import React from 'react';
import { PartnerV2 } from './types';

interface Props {
  partners: PartnerV2[];
  loading: boolean;
  isZh: boolean;
}

const PartnersGridV2: React.FC<Props> = ({ partners, loading, isZh }) => {
  if (loading) {
    return (
      <div className="text-center py-32 text-black/50 text-sm tracking-[0.25em] uppercase">
        {isZh ? '載入中⋯' : 'Loading…'}
      </div>
    );
  }
  if (!partners.length) {
    return (
      <div className="text-center py-32 text-black/50 text-sm tracking-[0.25em] uppercase">
        {isZh ? '暫無合作夥伴' : 'No partners yet'}
      </div>
    );
  }

  return (
    <section style={{ background: '#FAF9F1' }}>
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-20">
          {partners.map((p) => {
            const name = isZh ? p.companyName : (p.companyNameEn || p.companyName);
            const story = isZh ? p.story : (p.storyEn || p.story || '');
            const drink = isZh ? p.signatureDrinks : (p.signatureDrinksEn || p.signatureDrinks || '');
            const cover = (p.images && p.images[0]) || p.logoUrl || '';
            return (
              <article key={p._id} className="group">
                <div className="aspect-[4/5] overflow-hidden bg-black/5 mb-6">
                  {cover ? (
                    <img src={cover} alt={name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-black/10 to-black/25" />
                  )}
                </div>
                {(p.city || p.cityEn) && (
                  <p className="text-xs tracking-[0.3em] uppercase text-black/50 mb-3">
                    {isZh ? (p.city || '') : (p.cityEn || p.city || '')}
                  </p>
                )}
                <h3
                  className="text-3xl text-black leading-tight mb-4"
                  style={{ fontFamily: '"EB Garamond","Noto Serif TC",serif', fontWeight: 400 }}
                >
                  {name}
                </h3>
                {story && (
                  <p className="text-sm leading-[1.95] text-black/70 line-clamp-4 mb-4">{story}</p>
                )}
                {drink && (
                  <p className="text-xs tracking-[0.2em] uppercase text-black/55 border-t border-black/15 pt-4">
                    {isZh ? '招牌飲品 · ' : 'Signature · '}
                    <span className="normal-case tracking-normal text-black/80">{drink}</span>
                  </p>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PartnersGridV2;
